module.exports = __webpack_public_path__ + "img/voice.17fe5cbf.jpg";